import { MediaFeedType } from '@optools/services/operator-gateway/types/generated/graphql';

const mediaTypePriority = {
  [MediaFeedType.AWAY]: 100,
  [MediaFeedType.HOME]: 50,
  [MediaFeedType.NATIONAL]: 25,
  [MediaFeedType.UNKNOWN]: 0,
};

export function sortByFeedType<T extends { feedType: MediaFeedType }>(items: T[]) {
  return items.toSorted((a, b) => mediaTypePriority[b.feedType] - mediaTypePriority[a.feedType]);
}
